import { AlertSnooze20Regular, ArrowDown12Regular, ArrowLeft16Filled, ArrowLeft16Regular, ArrowRight16Filled, ArrowRight16Regular, ArrowSync16Regular, ArrowTrending20Regular, ArrowUp12Regular, ArrowUp16Regular, Attach20Filled, Attach20Regular, bundleIcon, CalendarEmpty20Filled, CalendarEmpty20Regular, CalendarLtr20Filled, CalendarLtr20Regular, ChevronDown20Regular, ChevronUp20Regular, Clock20Filled, Clock20Regular, Cloud20Filled, Cloud20Regular, Comment20Filled, Comment20Regular, CompassNorthwest20Regular, Desktop20Filled, Desktop20Regular, Dismiss12Filled, Dismiss12Regular, Dismiss20Filled, Dismiss20Regular, Document20Filled, Document20Regular, DocumentPdf20Filled, DocumentPdf20Regular, Edit20Filled, Edit20Regular, EyeOff20Filled, EyeOff20Regular, Filter20Filled, Filter20Regular, Fluid20Filled, Fluid20Regular, Globe20Filled, Globe20Regular, Image20Filled, Image20Regular, LayerDiagonal20Filled, LayerDiagonal20Regular, Mention20Filled, Mention20Regular, Navigation20Filled, Navigation20Regular, News20Regular, Notepad20Filled, Notepad20Regular, Open20Regular, People20Filled, People20Regular, PeopleCommunity20Filled, PeopleCommunity20Regular, Person20Filled, Person20Regular, Pin20Filled, PinOff20Filled, Search16Regular, Star20Filled, Star20Regular, TaskListLtr20Filled, TaskListLtr20Regular, VideoClip20Filled, VideoClip20Regular, VideoClipMultiple20Regular, Whiteboard20Filled, Whiteboard20Regular, WindowNew20Regular, } from '@fluentui/react-icons';
import React from 'react';
import { useStyles } from './EdgeworthIcon.styles';
export var EdgeworthIcon = function (_a) {
    var iconName = _a.iconName, filled = _a.filled;
    var styles = useStyles();
    var Component = undefined;
    switch (iconName) {
        case 'ArrowLeftIcon':
            var ArrowLeftIcon = bundleIcon(ArrowLeft16Filled, ArrowLeft16Regular);
            Component = (React.createElement(ArrowLeftIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'ArrowRightIcon':
            var ArrowRightIcon = bundleIcon(ArrowRight16Filled, ArrowRight16Regular);
            Component = (React.createElement(ArrowRightIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'ArrowSortDownIcon':
            Component = React.createElement(ArrowDown12Regular, null);
            break;
        case 'ArrowSortUpIcon':
            Component = React.createElement(ArrowUp12Regular, null);
            break;
        case 'AttachIcon':
            var AttachIcon = bundleIcon(Attach20Filled, Attach20Regular);
            Component = (React.createElement(AttachIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'BackToTopIcon':
            Component = React.createElement(ArrowUp16Regular, null);
            break;
        case 'CalendarEmptyIcon':
            var CalendarEmptyIcon = bundleIcon(CalendarEmpty20Filled, CalendarEmpty20Regular);
            Component = (React.createElement(CalendarEmptyIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'CalendarIcon':
            var CalendarIcon = bundleIcon(CalendarLtr20Filled, CalendarLtr20Regular);
            Component = (React.createElement(CalendarIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'ChevronDownIcon':
            Component = React.createElement(ChevronDown20Regular, null);
            break;
        case 'ChevronUpIcon':
            Component = React.createElement(ChevronUp20Regular, null);
            break;
        case 'ClockIcon':
            var ClockIcon = bundleIcon(Clock20Filled, Clock20Regular);
            Component = (React.createElement(ClockIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'CloudIcon':
            var CloudIcon = bundleIcon(Cloud20Filled, Cloud20Regular);
            Component = (React.createElement(CloudIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'CommentIcon':
            var CommentIcon = bundleIcon(Comment20Filled, Comment20Regular);
            Component = (React.createElement(CommentIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'CompassIcon':
            Component = React.createElement(CompassNorthwest20Regular, null);
            break;
        case 'DesktopIcon':
            var DesktopIcon = bundleIcon(Desktop20Filled, Desktop20Regular);
            Component = (React.createElement(DesktopIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'DismissIcon':
            var DismissIcon = bundleIcon(Dismiss20Filled, Dismiss20Regular);
            Component = (React.createElement(DismissIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'DocumentIcon':
            var DocumentIcon = bundleIcon(Document20Filled, Document20Regular);
            Component = (React.createElement(DocumentIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'EditIcon':
            var EditIcon = bundleIcon(Edit20Filled, Edit20Regular);
            Component = (React.createElement(EditIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'EyeHideIcon':
            var EyeHideIcon = bundleIcon(EyeOff20Filled, EyeOff20Regular);
            Component = (React.createElement(EyeHideIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'FilterIcon':
            var FilterIcon = bundleIcon(Filter20Filled, Filter20Regular);
            Component = (React.createElement(FilterIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'FluidIcon':
            var FluidIcon = bundleIcon(Fluid20Filled, Fluid20Regular);
            Component = (React.createElement(FluidIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'GlobeIcon':
            var GlobeIcon = bundleIcon(Globe20Filled, Globe20Regular);
            Component = (React.createElement(GlobeIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'ImageIcon':
            var ImageIcon = bundleIcon(Image20Filled, Image20Regular);
            Component = (React.createElement(ImageIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'LayerIcon':
            var LayerIcon = bundleIcon(LayerDiagonal20Filled, LayerDiagonal20Regular);
            Component = (React.createElement(LayerIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'MentionIcon':
            var MentionIcon = bundleIcon(Mention20Filled, Mention20Regular);
            Component = (React.createElement(MentionIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'NavigationIcon':
            var NavigationIcon = bundleIcon(Navigation20Filled, Navigation20Regular);
            Component = (React.createElement(NavigationIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'NewsIcon':
            Component = React.createElement(News20Regular, null);
            break;
        case 'NotepadIcon':
            var NotepadIcon = bundleIcon(Notepad20Filled, Notepad20Regular);
            Component = (React.createElement(NotepadIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'OpenIcon':
            Component = React.createElement(Open20Regular, null);
            break;
        case 'PdfIcon':
            var PdfIcon = bundleIcon(DocumentPdf20Filled, DocumentPdf20Regular);
            Component = (React.createElement(PdfIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'PeopleCommunityIcon':
            var PeopleCommunityIcon = bundleIcon(PeopleCommunity20Filled, PeopleCommunity20Regular);
            Component = (React.createElement(PeopleCommunityIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'PeopleIcon':
            var PeopleIcon = bundleIcon(People20Filled, People20Regular);
            Component = (React.createElement(PeopleIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'PersonIcon':
            var PersonIcon = bundleIcon(Person20Filled, Person20Regular);
            Component = (React.createElement(PersonIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'PinIcon':
            Component = React.createElement(Pin20Filled, null);
            break;
        case 'PinOffIcon':
            Component = React.createElement(PinOff20Filled, null);
            break;
        case 'SearchIcon':
            Component = React.createElement(Search16Regular, null);
            break;
        case 'SmallDismissIcon':
            var SmallDismissIcon = bundleIcon(Dismiss12Filled, Dismiss12Regular);
            Component = (React.createElement(SmallDismissIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'SnoozeExpiryIcon':
            Component = React.createElement(AlertSnooze20Regular, null);
            break;
        case 'StarIcon':
            var StarIcon = bundleIcon(Star20Filled, Star20Regular);
            Component = (React.createElement(StarIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'SyncIcon':
            Component = React.createElement(ArrowSync16Regular, null);
            break;
        case 'TaskIcon':
            var TaskIcon = bundleIcon(TaskListLtr20Regular, TaskListLtr20Filled);
            Component = (React.createElement(TaskIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'TrendingIcon':
            Component = React.createElement(ArrowTrending20Regular, null);
            break;
        case 'VideoIcon':
            var VideoIcon = bundleIcon(VideoClip20Regular, VideoClip20Filled);
            Component = (React.createElement(VideoIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
        case 'VideoClipMultipleIcon':
            Component = React.createElement(VideoClipMultiple20Regular, null);
            break;
        case 'WindowNewIcon':
            Component = React.createElement(WindowNew20Regular, null);
            break;
        case 'WhiteboardIcon':
            var WhiteboardIcon = bundleIcon(Whiteboard20Filled, Whiteboard20Regular);
            Component = (React.createElement(WhiteboardIcon, { filled: true, className: filled ? styles['filled'] : styles['regular'] }));
            break;
    }
    return Component ? React.createElement("span", null, Component) : null;
};
//# sourceMappingURL=EdgeworthIcon.js.map